import React, { Component } from "react"

const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

class ChatPage extends Component {

    async componentDidMount() {
        while (true) {
            if (!window.ChannelIO) {
                await sleep(100)
                continue
            }
            else {
                window.ChannelIO('onBoot', async () => {
                    window.ChannelIO('openChat')
                    while (true) {
                        const el = document.getElementById('ch-plugin-script')
                        if (!el.className || !el.className.includes('rightPosition')) {
                            await sleep(100)
                            continue
                        }
                        el.className = el.className.replace('rightPosition', '')
                        el.style.left = 'calc(50vw - 180px)'
                        el.style.top = 'calc(7vh)'

                        break
                    }
                })
                break
            }
        }
    }

    render() {
        return <div style={{ width: '100vw', height: '100vh', backgroundColor: "#eeeeee" }}></div>
    }
}

export default ChatPage